<template>
  <div class="pane-box">
    <el-form ref="recordFormSearch" :inline="true" :model="form" label-width="80px">
      <el-form-item label="订购时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="form.startTime"
            type="datetime"
            :placeholder="'选择日期时间'"
            :picker-options="pickerOptionsStart()"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd()"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button class="search" @click="queryList">
          <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i>
          查询
        </el-button>
        <el-button class="b2" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table-box">
      <el-table
        :data="list"
        style="width: 100%; opacity: 1"
        tooltip-effect="light"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column width="30"></el-table-column>
        <el-table-column prop="orderName" label="服务名称" width="210"></el-table-column>
        <el-table-column prop="cycle" label="周期">
          <template slot-scope="scope">
            <span v-if="scope.row.cycle">{{ scope.row.cycle }}天
              
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="invalidateDate" label="有效期" width="320"></el-table-column>
        <el-table-column prop="money" label="金额（元）"></el-table-column>
        <el-table-column prop="crtime" label="支付时间" width="220"></el-table-column>
        <el-table-column prop="payStatusStr" label="支付状态" width="180">
        </el-table-column>
        <el-table-column prop="orderNo" label="交易流水号" width="500"></el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: right; margin-top: 20px; margin-right: 120px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="pageForm.current"
      >
      </el-pagination>
    </div>
  </div>
</template>
  
<script>  
import {getList} from "@/api/backstage/addService.js";
export default {
  name: '' ,
  components: {},
  props:{},
  data() {
    return {
      form:{
        startTime:'',
        endTime:'',
      },
      pageForm:{
        size:10,
        current:1,
      },
      list:[],
      total:0,
    }
  },
  computed: {},
  created() {
  
  },
  mounted() {
    this.reset();
  },
  methods: {
    queryList(){
      this.pageForm.current = 1
      this.getList();
    },
    reset(){
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      this.form.startTime = this.getDateStr(-30) + " 00:00:00";
      this.form.endTime = `${yy}-${mm}-${dd} 23:59:59`;
      this.queryList();
    },
    handleSizeChange(val){
      this.pageForm.size = val
      this.getList();
    },
    handleCurrentChange(val){
      this.pageForm.current = val
      this.getList();
    },
    getList(){
      getList({
        ...this.form,...this.pageForm,paySign:4
      }).then(res=>{
        if(res.code == 1){
          this.list = res.data.records;
          this.total = res.data.total
        }else{
          this.$message.error(res.message)
        }
      })
    },
    clearTimeSendTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },
    pickerOptionsStart() {
      return {
        disabledDate: (time) => {
          if (this.form.endTime) {
            var flag = false;
            flag = time.getTime() > new Date(this.form.endTime).getTime();
            return flag;
          }
        },
      };
    },
    pickerOptionsEnd() {
      return {
        disabledDate: (time) => {
          var flag = false;
          if (this.form.startTime) {
            return time.getTime() < new Date(this.form.startTime).getTime() || flag;
          }
        },
      };
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  color: #fe4d45;
  border: 1px solid #fe4d45;
}
.auditSuccessful_ok {
    position: absolute;
    top: 40%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #fe4d45;
    border-radius: 50%;
    opacity: 1;
  }
  .auditSuccessful_title {
    text-align: center;
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    opacity: 1;
  }
</style>